import { render, staticRenderFns } from "./ShowItems.vue?vue&type=template&id=867677b0&scoped=true"
import script from "./ShowItems.vue?vue&type=script&lang=js"
export * from "./ShowItems.vue?vue&type=script&lang=js"
import style0 from "./ShowItems.vue?vue&type=style&index=0&id=867677b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867677b0",
  null
  
)

export default component.exports